@if (hasTiles()) {
  <section class="page-explore" aria-labelledby="page-explore-heading">
    <p class="page-explore-kicker groove-type-eyebrow">
      <span class="groove-arc-swash" id="page-explore-heading">Explore</span>
    </p>
    <div class="page-explore-grid groove-related-tiles">
      @for (t of tiles(); track t.href) {
        <div
          class="groove-related-tile"
          grooveSurface
          variant="bordered"
          tone="raised"
          size="lg"
          [elevation]="1"
        >
          <h2 class="groove-related-tile-title">{{ t.title }}</h2>
          <p class="groove-related-tile-blurb">{{ t.blurb }}</p>
          <a class="groove-related-tile-link" [routerLink]="t.href"
            >{{ t.cta }} &rarr;</a
          >
        </div>
      }
    </div>
  </section>
}
